export const IndexHeader = () => {
  return (
    <div>
      <section className="headernma bg-black w-full min-h-[280px] flex flex-col justify-center">
        <div className="px-16 flex justify-between ">
          <div className="flex flex-col">
            <h2 className="font-TCCC text-[64px] font-[600] text-white  max-h-[172px] leading-[86px]">
              2023/24 GALLERY
            </h2>
            <p className="max-w-[729px] text-white font-TCCCtext text-[14px] leading-[22px] mt-4">
              Here you'll find all entries that competed in Past Networked Marketing Awards. Every submission is a
              testament to the creativity and marketing excellence fueling our transformation journey.
            </p>
          </div>
          <div className="logo">
            <img src={require('assets/images/header/logo.png')} alt="Logo" className="h-[99px]" />
          </div>
        </div>
      </section>
    </div>
  )
}
